var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.footer)?_c('a',{staticClass:"dd-m-icon",attrs:{"title":_vm.title},on:{"click":_vm.isUserSigned}},[_c('i',{staticClass:"dd-m-icon",class:_vm.icon})]):_c('a',{staticClass:"dd-m-menu__link",attrs:{"title":_vm.title},on:{"click":_vm.isUserSigned}},[_c('i',{staticClass:"dd-m-icon icon-home"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f1ee260","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/site/js/components/bar-link.vue
// module id = 437
// module chunks = 2